import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SelectInput, useResourceContext, TopToolbar, ExportButton } from "react-admin";
import { Link } from "react-router-dom";
import { getNameAndCompanyName, getResource, monthChoices } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const ContactHistoryList = () => {
  const [customers,setCustomers]=useState([]);
  const resource = useResourceContext(); 
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {

  //     return {
  //       // "問い合わせNo": String(record.number).padStart(5, "0"), 
  //       "問い合わせ日": record.contactDate ? new Date(record.contactDate).toLocaleDateString() : "",
  //       "問い合わせ内容": record.content ?? "",
  //       "顧客名": getCustomer(record.customerId) ? `${getNameAndCompanyName(getCustomer(record.customerId).surname,getCustomer(record.customerId).name,getCustomer(record.customerId).companyName)}`: "",
  //     }
        
  //   });

  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `問い合わせ履歴_` + new Date().toLocaleDateString());
  // };

  const customExporter = (records) => {
  // エクセル用のデータ整形
    const excelData = records.map(record => {
      const customer = getCustomer(record.customerId);
      const customerName = customer
        ? getNameAndCompanyName(customer.surname, customer.name, customer.companyName)
        : "";

      return {
        "問い合わせ日": record.contactDate ? new Date(record.contactDate).toLocaleDateString() : "",
        "問い合わせ内容": record.content ?? "",
        "顧客名": customerName,
      };
    });

    // シート作成
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // セル幅の設定
    worksheet['!cols'] = [
      { wch: 14 },  // 問い合わせ日
      { wch: 120 },  // 問い合わせ内容
      { wch: 25 },  // 顧客名
    ];

    // ブック作成
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "問い合わせ履歴");

    // 書き出し
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `問い合わせ履歴_${new Date().toLocaleDateString()}.xlsx`);
  };
  
  const getCustomer = (customerId) =>{
    const customer = customers.find(req => req.id === customerId);
    return customer;
  }

  const CustomerFilters = [
    <SelectInput
      source="month"
      label={<span style={{fontSize:"12px"}}>問い合わせ月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" }, 
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/contactHistory"/>
      <ExportButton exporter={customExporter}/>
    </TopToolbar>
  );


  return (
    <List  filters={CustomerFilters} actions={<CustomersActions />}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false}>
      {/* <FunctionField source="number" label="問い合わせNo" render={(record) => {
        return String(record.number).padStart(5, "0");
      }}/> */}
      <DateField source="contactDate" label="問い合わせ日" />
      <TextField source="content" label="問い合わせ内容" />
        <FunctionField
          source="customerId"
          label="顧客名"
          render={(record) => {
            const customer = getCustomer(record.customerId)
            return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{`${getNameAndCompanyName(customer.surname,customer.name,customer.companyName)}`}</Link> : "";
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </Datagrid>
    </List>
  );
}

export default ContactHistoryList;
